import React, { Component } from 'react';
import { Tabs, Button, Icon } from 'antd';
import FormDragLayout from '../FormDragLayout';
import { connect as reduxConnect } from 'react-redux';
import { addTabs, reorderTabs, deleteTabs, removeForm } from "../../../../../../stateManager/store/formCreation/action"
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { DragSource, DropTarget } from 'react-dnd';
import { fCardSelect } from '../../../../../../helpers/RxServices';
import { DeleteModal } from '../../../../../../helpers/commonUi/DeleteModal';
import { setSelectedItemId } from '../../../../../../stateManager/store/contextMenu/action';
import { Modal } from '../../../../../../helpers/commonUi';
import style from '../../../../../apps/forms/formBuilder/formbuilder.module.sass'

const { TabPane } = Tabs;

type TabsState = {
    activeTab: string;
    deleteTabId: string;
    deleteVisible: boolean;
}

type FormsTabsProps = {
    canEdit: boolean,
    formCreation: any;
    selectedAppType: string | null;
    addTabs: (formId: string, tabId: string, tabName?: string) => void;
    reorderTabs: (orderedTabs: string[], formId: string) => void;
    deleteTabs: (deleteTabId: string, formId: string) => void;
    removeForm: (formId: Object) => void;
    match: any;
    setSelectedItemId: (tabId: string) => void;
} & RouteComponentProps

class FormsTabs extends Component<FormsTabsProps, TabsState> {
    constructor(props: FormsTabsProps) {
        super(props);
        this.state = {
            activeTab: "tab-0",
            deleteTabId: "",
            deleteVisible: false
        }
    }

    componentDidMount = () => {
        // this.props.addTabs(formId, "tab-0", "Tab 0");
        let { formCreation, match } = this.props;
        let currentFormsTab = formCreation[match.params.formId];

        if (!currentFormsTab || !currentFormsTab.length) {
            this.props.addTabs(match.params.formId, `tab-0`, `Tab 1`);
            this.onTabClick("tab-0");
        } else {
            this.onTabClick(currentFormsTab[0].id);
        }
    }

    add = () => {
        let { formCreation, match } = this.props;
        let formId = match.params.formId;
        let currentFormsTab = formCreation[match.params.formId];

        const idArray = (currentFormsTab.length > 0) && currentFormsTab.map((item: any) => {
            return parseInt(item.id.split('-')[1])
        });
        const newTabKey = (idArray.length > 0) ? Math.max(...idArray) + 1 : 0;
        this.props.addTabs(formId, `tab-${newTabKey}`, `Tab ${newTabKey + 1}`)
    };

    onTabClick = (tabId: string) => {
        let { formCreation, match } = this.props;
        let currentFormsTab: any[] = formCreation[match.params.formId];
        let tabJson = currentFormsTab && currentFormsTab.filter(x => x.id === tabId)[0];
        const selectedSection = tabId.split("#").slice(0, 2).join("#");
        fCardSelect.sendMessage({ id: tabId, json: { ...tabJson, selectedSection } });
        this.setState({ activeTab: tabId });
        this.props.setSelectedItemId(tabId)
    }



    onDeleteClick = (tabId: string) => {
        this.setState({ deleteVisible: true, deleteTabId: tabId })
    }

    onDeleteTabs = async () => {
        //do delete
        let { deleteTabId } = this.state;
        let formId = this.props.match.params.formId;
        await this.props.deleteTabs(deleteTabId, formId);
        this.setState({ deleteVisible: false, deleteTabId: "" })
    }

    getDeleteTabName = () => {
        let { formCreation, match } = this.props;
        let { deleteTabId } = this.state;
        let tabs = formCreation[match.params.formId];
        if (deleteTabId) {
            return tabs.filter((x: any) => x.id === deleteTabId).length > 0 ? tabs.filter((x: any) => x.id === deleteTabId)[0].name : ""
        }
        return ""
    }

    renderTabName = (pane: any, allTabs: any[]) => {
        return (
            <div>
                {pane.name}
                {pane.id === this.state.activeTab && allTabs.length > 1 && this.props.canEdit &&
                    <Icon type="close"
                        data-test-id="close"
                        style={{ color: "red", fontWeight: 400, fontSize: "12px", position: "relative", top: "-2px", left: "12px" }}
                        onClick={() => this.onDeleteClick(pane.id)}
                    />}
            </div>
        )
    }

    // componentWillUnmount() {
        // this.props.removeForm({id :  this.props.match.params.formId})
    //  }
    render() {
        let { formCreation, match } = this.props;
        let { deleteVisible, activeTab } = this.state;
        let tabs = formCreation[match.params.formId];
        const operations = this.props.canEdit && this.props.selectedAppType !== "a8assist" && (
            <Button data-test-id="plus_icon" onClick={this.add} shape="circle" size="small">
                <Icon type="plus" style={{ position: "absolute", top: "3px", left: "4px" }} />
            </Button>
        );
        return (
            <>
                <DraggableTabs
                    data-test-id="dragable_tabs"
                    tabBarExtraContent={operations}
                    onTabClick={this.onTabClick}
                    reorderTabs={(orderedTabs) => this.props.reorderTabs(orderedTabs, match.params.formId)}>
                    {tabs && tabs.map((pane: any, i: number) => (
                        <TabPane data-test-id={`render_tab${pane.id}`} tab={this.renderTabName(pane, tabs)} key={pane.id}>
                            {activeTab === pane.id && <FormDragLayout data-test-id={`${pane.id}`} canEdit={this.props.canEdit} tabId={pane.id} />}
                        </TabPane>
                    ))}
                    {/* </Tabs> */}
                </DraggableTabs>

                <Modal
                    id="delete_tab"
                    dataTestId="delete_tab"
                    title={
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <p style={{ marginBottom: 0 }}>{`Delete ${this.getDeleteTabName()}`}</p>
                            <div className={style.delete_closeIcon} onClick={() => { this.setState({ deleteVisible: false }) }}>X</div>
                        </div>
                    }
                    closable={false}
                    unmountOnCancel={true}
                    visible={deleteVisible}
                    onCancel={() => {
                        this.setState({ deleteVisible: false })
                    }}
                    footer={{
                        OkButtonColor: "shadow-secondary",
                        enable: true,
                        okText: "DELETE",
                        cancelText: "CANCEL",
                        onOk: () => {
                            this.onDeleteTabs();
                        }
                    }}
                > <div className={style.modalMsg}>
                        Are you sure to delete {this.getDeleteTabName()}?
                    </div>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: any, props: any) => {
    return {
        formCreation: state.formcreation,
        selectedAppType: state.apps && state.apps.selectedApp && state.apps.selectedApp.type
    }
}

export default reduxConnect(mapStateToProps, { addTabs, reorderTabs, deleteTabs, removeForm, setSelectedItemId })(withRouter(FormsTabs));






class TabNode extends React.Component<any, any> {
    render() {
        const { connectDragSource, connectDropTarget, children } = this.props;

        return connectDragSource(connectDropTarget(children));
    }
}

const cardTarget = {
    drop(props: any, monitor: any) {
        const dragKey = monitor.getItem().index;
        const hoverKey = props.index;

        if (dragKey === hoverKey) {
            return;
        }

        props.moveTabNode(dragKey, hoverKey);
        monitor.getItem().index = hoverKey;
    },
};

const cardSource = {
    beginDrag(props: any) {
        return {
            id: props.id,
            index: props.index,
        };
    },
};



const WrapTabNode = DropTarget('DND_NODE', cardTarget, connect => ({
    connectDropTarget: connect.dropTarget(),
}))(
    DragSource('DND_NODE', cardSource, (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    }))(TabNode),
);

type State = {
    order: string[];
}

type Props = {
    onTabClick?: Function;
    tabBarExtraContent?: React.ReactNode | null;
    size?: 'large' | 'default' | 'small';
    style?: React.CSSProperties;
    prefixCls?: string;
    className?: string;
    reorderTabs?: (orderedTabs: string[]) => void;
}

class DraggableTabs extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            order: [],
        };
    }


    moveTabNode = (dragKey: any, hoverKey: any) => {
        const newOrder = this.state.order.slice();
        const { children } = this.props;

        React.Children.forEach(children, (c: any) => {
            if (newOrder.indexOf(c.key) === -1) {
                newOrder.push(c.key);
            }
        });

        const dragIndex = newOrder.indexOf(dragKey);
        const hoverIndex = newOrder.indexOf(hoverKey);

        newOrder.splice(dragIndex, 1);
        newOrder.splice(hoverIndex, 0, dragKey);

        this.props.reorderTabs!(newOrder);

        this.setState({
            order: newOrder,
        });
    };

    renderTabBar = (props: Props, DefaultTabBar: any) => (
        <DefaultTabBar {...props}>
            {(node: any) => (
                <WrapTabNode key={node.key} index={node.key} moveTabNode={this.moveTabNode}>
                    {node}
                </WrapTabNode>
            )}
        </DefaultTabBar>
    );

    render() {
        const { order } = this.state;
        const { children } = this.props;
        const tabs: any[] = [];
        React.Children.forEach(children, c => {
            tabs.push(c);
        });

        const orderTabs = tabs.slice().sort((a: any, b: any) => {
            const orderA = order.indexOf(a.key);
            const orderB = order.indexOf(b.key);

            if (orderA !== -1 && orderB !== -1) {
                return orderA - orderB;
            }
            if (orderA !== -1) {
                return -1;
            }
            if (orderB !== -1) {
                return 1;
            }

            const ia = tabs.indexOf(a);
            const ib = tabs.indexOf(b);

            return ia - ib;
        });

        return (
            <Tabs renderTabBar={this.renderTabBar} {...this.props}>
                {orderTabs}
            </Tabs>
        );
    }
}
